/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react'
import { CssBaseline, ThemeProvider } from "@mui/material"
import { ColorModeContext, useMode } from "./theme"
import Routes from './routes'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { auth, db } from './firebase'
import { doc, setDoc, getDoc } from 'firebase/firestore'

class DateAdapter extends AdapterDayjs {
    getWeekdays = (): string[] => ['日', '月', '火', '水', '木', '金', '土'];
}

function App() {
  const [theme, colorMode] = useMode()

  // ユーザードキュメントの自動作成
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const userDocRef = doc(db, 'users', user.uid)
        const userDoc = await getDoc(userDocRef)

        if (!userDoc.exists()) {
          // ユーザードキュメントが存在しない場合は作成
          await setDoc(userDocRef, {
            email: user.email,
            isAdmin: false
          })
          console.log('User document created:', user.uid)
        }
      }
    })

    return () => unsubscribe()
  }, [])

  return (
    <ColorModeContext.Provider value={colorMode as any}>
      <ThemeProvider theme={theme as any}>
        <CssBaseline />
        <LocalizationProvider
          dateAdapter={DateAdapter}
          dateFormats={{ monthAndYear: "YYYY年 MM月", monthShort: "MM月" }}
          adapterLocale={"ja"}
        >
          <Routes />
          <ToastContainer/>
        </LocalizationProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  )
}

export default App
